//require('./bootstrap');
require('@noardcode/compass-core')
//require('@noardcode/compass-financial')
require('@noardcode/compass-crm')

$(function () {
    require('@noardcode/compass-media-library');
})

window.tinymce = require("tinymce/tinymce")
require('tinymce/themes/silver');
require('tinymce/plugins/hr');
require('tinymce/plugins/table');
require('tinymce/plugins/lists');
require('tinymce/plugins/link');
require('tinymce/plugins/autolink');
require('tinymce/plugins/wordcount');
require('tinymce/plugins/code');
require('tinymce/plugins/image');


// require('photoswipe');


// require("./projects")
// require("../../../public/vendor/tinymce")
//
//
$(document).ready(function () {
    if ($(".text-editor").length) {
        require('./modules/tinymce');
    }
});
